import { listBoxGroupNameDefaultStyle, listBoxItemDefaultStyle, listBoxPaperDefaultStyle } from './listBoxDefaultStyle';
export const listBoxPaperStyleBuilder = (theme, maxHeight, maxWidth, minWidth) => {
  const style = listBoxPaperDefaultStyle(theme, maxHeight, maxWidth, minWidth);
  return style;
};
export const listBoxItemStyleBuilder = (theme, size) => {
  return listBoxItemDefaultStyle(theme, size);
};
export const listBoxGroupHeaderStyleBuilder = (theme, size) => ({
  ...listBoxItemDefaultStyle(theme, size),
  ...listBoxGroupNameDefaultStyle(theme, size)
});